import CONSTANT from '../constant/category'
import service from '../service/category'

export default {
  getCategoryChildren({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      return service.getCategoryChildren(data).then(result => {
        commit(CONSTANT.CATEGORY_GET_CHILDREN_SUCCESS, result)
        resolve(result)
      }, e => {
        commit(CONSTANT.CATEGORY_GET_CHILDREN_ERROR, e)
        reject(e)
      })
    })
  },
  getCategoryProducts({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      return service.getCategoryProducts(data).then(result => {
        commit(CONSTANT.CATEGORY_GET_PRODUCTS_SUCCESS, result)
        resolve(result)
      }, e => {
        commit(CONSTANT.CATEGORY_GET_PRODUCTS_ERROR, e)
        reject(e)
      })
    })
  },
  getCategoryProductsMore({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      return service.getCategoryProducts(data).then(result => {
        commit(CONSTANT.CATEGORY_GET_PRODUCTS_MORE_SUCCESS, result)
        resolve(result)
      }, e => {
        commit(CONSTANT.CATEGORY_GET_PRODUCTS_MORE_ERROR, e)
        reject(e)
      })
    })
  },
  getRecommendByCategory({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      return service.getRecommendByCategory(data).then(result => {
        commit(CONSTANT.CATEGORY_GET_PRODUCTS_SUCCESS, result)
        resolve(result)
      }, e => {
        commit(CONSTANT.CATEGORY_GET_PRODUCTS_ERROR, e)
        reject(e)
      })
    })
  },
  getRecommendByCategoryMore({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      return service.getRecommendByCategory(data).then(result => {
        commit(CONSTANT.CATEGORY_GET_PRODUCTS_MORE_SUCCESS, result)
        resolve(result)
      }, e => {
        commit(CONSTANT.CATEGORY_GET_PRODUCTS_MORE_ERROR, e)
        reject(e)
      })
    })
  },
  getCategoryInfo({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      return service.getCategoryInfo(data).then(result => {
        resolve(result)
      }, e => {
        reject(e)
      })
    })
  },
  getCategoryBanner({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      return service.getCategoryBanner(data).then(result => {
        commit(CONSTANT.CATEGORY_GET_BANNER_SUCCESS, result)
        resolve(result)
      }, e => {
        commit(CONSTANT.CATEGORY_GET_BANNER_ERROR, e)
        reject(e)
      })
    })
  },
  getCategoryRecommend({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      return service.getCategoryRecommend(data).then(result => {
        resolve(result)
        commit(CONSTANT.CATEGORY_GETCATEGORYRECOMMEND_SUCCESS, result)
        return result
      }, e => {
        reject(e)
        commit(CONSTANT.CATEGORY_GETCATEGORYRECOMMEND_ERROR, e)
      })
    })
  },
  getCategoryOptions({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      return service.getCategoryOptions(data).then(result => {
        resolve(result)
        commit(CONSTANT.CATEGORY_GET_OPTIONS_SUCCESS, result)
        return result
      }, e => {
        reject(e)
        commit(CONSTANT.CATEGORY_GET_OPTIONS_ERROR, e)
      })
    })
  },
  getCateOpProducts({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      return service.getCateOpProducts(data).then(result => {
        resolve(result)
        commit(CONSTANT.CATEGORY_GET_OPTION_PRODUCTS_SUCCESS, result)
        return result
      }, e => {
        reject(e)
        commit(CONSTANT.CATEGORY_GET_OPTION_PRODUCTS_ERROR, e)
      })
    })
  },
  getCateOpProductsMore({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      return service.getCateOpProducts(data).then(result => {
        resolve(result)
        commit(CONSTANT.CATEGORY_GET_OPTION_PRODUCTS_MORE_SUCCESS, result)
        return result
      }, e => {
        reject(e)
      })
    })
  },
  getCategoryFitlers({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      return service.getCategoryFitlers(data).then(result => {
        resolve(result)
        return result
      }, e => {
        reject(e)
      })
    })
  },
  filterProductList({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      return service.filterProductList(data).then(result => {
        resolve(result)
        return result
      }, e => {
        reject(e)
      })
    })
  },
  filterOptionList({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      return service.filterOptionList(data).then(result => {
        commit(CONSTANT.CATEGORY_GET_FILTER_OPTIONS_SUCCESS, result)
        resolve(result)
      }, e => {
        commit(CONSTANT.CATEGORY_GET_FILTER_OPTIONS_ERROR, e)
        reject(e)
      })
    })
  },
  submitFilterOption({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      return service.submitFilterOption(data).then(result => {
        commit(CONSTANT.CATEGORY_SUBMIT_FILTER_OPTIONS_SUCCESS, result)
        resolve(result)
      }, e => {
        commit(CONSTANT.CATEGORY_SUBMIT_FILTER_OPTIONS_ERROR, e)
        reject(e)
      })
    })
  },
  submitFilterOptionMore({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      return service.submitFilterOption(data).then(result => {
        commit(CONSTANT.CATEGORY_SUBMIT_FILTER_OPTIONS_MORER_SUCCESS, result)
        resolve(result)
      }, e => {
        commit(CONSTANT.CATEGORY_SUBMIT_FILTER_OPTIONS_MORE_ERROR, e)
        reject(e)
      })
    })
  },

  // 存储筛选条件
  saveFilterOptions({
    commit
  }, save_data) {
    return new Promise((resolve, reject) => {
      commit(CONSTANT.CATEGORY_SAVE_FILTER_OPTIONS, save_data)
      resolve()
    })
  },

  // 清空筛选条件
  clearFIlterOptions({
    commit
  }, save_data) {
    return new Promise((resolve, reject) => {
      commit(CONSTANT.CATEGORY_CLEAR_FILTER_OPTIONS, {})
      resolve()
    })
  },

  // 暂存表单数据
  saveFilterOptionsCondition({
    commit
  }, save_condition) {
    return new Promise((resolve, reject) => {
      commit(CONSTANT.CATEGORY_SAVE_FILTER_OPTIONS_CONDITION, save_condition)
      resolve()
    })
  },
  // 清空暂存表单数据
  clearFilterOptionsCondition({
    commit
  }, save_condition) {
    return new Promise((resolve, reject) => {
      commit(CONSTANT.CATEGORY_CLEAR_FILTER_OPTIONS_CONDITION)
      resolve()
    })
  },


  getWelfareProductList({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      return service.getWelfareProductList(data).then(result => {
        resolve(result)
        return result
      }, e => {
        reject(e)
      })
    })
  },
  /*yeoman-template-point-1*/
}
